/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PatientInterface } from 'medicalsystem-shared';

/**
 * Type for card origin position in Kanban board drag-and-drop operations.
 */
export type CardOriginPosition = {
    fromPosition: number,
    fromColumnId: string
}

export type DestinationCardPosition = {
    toPosition: number,
    toColumnId: string
}

export type CardPositionChange = {
    from: CardOriginPosition,
    to: DestinationCardPosition
    tabIndex: number
}

/**
 * Type for individual card in Kanban board with JSX template.
 */
export type BoardCardType = {
    id: string;
    key?: string;
    template: JSX.Element;
}

export type BoardType = {
    columns: {
        id: string;
        key?: string;
        title: string;
        cards: BoardCardType[];
    }[];
}

// For localStorage

export enum FormType{
    PatientForm = 'PatientForm'
} 

export type StoredBoardCardType = {
    id: string;
    model: PatientInterface
    formType: FormType
}

export type StoredBoardType = {
    columns: {
        id: string;
        title: string;
        cards: StoredBoardCardType[];
    }[]
}

export type TabType = {
    index?: number
    boards?: StoredBoardType;
};

/**
 * Redux state for managing main container tabs with Kanban boards.
 */
export type MainContainerState = {
    tabs: TabType[];
    tabCounter?: number
};

const initialState:MainContainerState = {
    tabs:[],
    tabCounter: 0 
}

/**
 * Adds a new tab to the container state.
 * @param state - Current main container state
 * @param action - Payload containing tab data
 */
const addTab = (state: MainContainerState, action: PayloadAction<TabType>) => {
    state.tabs.push(action.payload);
};

const newTab = (state: MainContainerState) => {
    const newIndex = state.tabCounter + 1;
    state.tabs.push({
        index: newIndex
    });
    state.tabCounter = newIndex;
};

/**
 * Handles drag-and-drop card position changes in Kanban board.
 * Moves card from origin column to destination column at specified positions.
 * @param state - Current main container state
 * @param action - Payload containing card position change data
 */
const changeCardPosition = (state: MainContainerState, action: PayloadAction<CardPositionChange>) => {

    let from = action.payload.from;
    let to = action.payload.to;
    let tabIndex = action.payload.tabIndex;

    console.log(JSON.stringify(action.payload));

    const tabs = [...state.tabs];

    const orgCol = tabs[tabIndex].boards?.columns.find(col => col.id === from.fromColumnId);
    const detCol = tabs[tabIndex].boards?.columns.find(col => col.id === to.toColumnId);

    if(orgCol){
        const orgCard = orgCol.cards[from.fromPosition]
        if(orgCard && detCol){
            detCol.cards.splice(to.toPosition, 0, orgCard);
            orgCol.cards.splice(from.fromPosition, 1);
            console.log("checkpoint")
        }
    }

    state.tabs = tabs;

    const cont1 = tabs[tabIndex].boards.columns[0].cards.length;
    const cont2 = tabs[tabIndex].boards.columns[1].cards.length;
    console.log("col1 count:"+cont1+", col2 count:"+cont2 )
}

const saveBoard = (state: MainContainerState, action: PayloadAction<TabType>) => {
    const tab = state.tabs.find(t => t.index && t.index === action.payload.index);
    if(tab){
        state.tabs[tab.index] = {index:action.payload.index, boards: action.payload.boards}
    }
};

const ContainerSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        addTab,
        newTab,
        saveBoard,
        changeCardPosition
    },
  });

  export default ContainerSlice;



